import React from "react";
import "./index.css";

/* Import imgs */
import service1 from "../assets/services1.png";
import service2 from "../assets/services2.png";
import service3 from "../assets/services3.png";
import service4 from "../assets/services4.png";
import service5 from "../assets/services5.png";
import service6 from "../assets/services6.png";

import { useCons } from "../context/ConsContext";

const Services = () => {
  const { buttonData } = useCons();

  const listServices = [
    {
      id: "collision",
      name: "Collision",
      img: service1,
    },
    {
      id: "bumper_repair",
      name: "Bumper Repair",
      img: service2,
    },
    {
      id: "repainting",
      name: "Repainting",
      img: service3,
    },
    {
      id: "polish_and_detailing",
      name: "Polish And Detailing",
      img: service4,
    },
    {
      id: "insurance_services",
      name: "Insurance Services",
      img: service5,
    },
    {
      id: "and_more",
      name: "And More",
      img: service6,
    },
  ];

  return (
    <div className="section">
      <div className="container-sm flex flexCol alignCenter">
        <h2 className="textCenter">Our Services (Free Estimates)</h2>
        <p className="textCenter">
          Discover the journey of Silver Star Collision Center, a trusted name
          in auto care.
        </p>
        <div className="flex flexRow flexWrap space serviceDiv">
          {listServices.map((item) => (
            <div className="serviceCard" key={item.id}>
              <img src={item.img} alt={item.name} />
              <h3>{item.name}</h3>
            </div>
          ))}
        </div>
        <button className="btn" onClick={() => buttonData(true)}>
          Free Estimate
        </button>
      </div>
    </div>
  );
};

export default Services;
